export default __webpack_public_path__ + "static/media/ponce_health_sciences.67b09996.png";